import React from 'react';

const LoadingModal = () => {
  return (
    <div className="modal d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content text-center p-4">
          <div className="modal-body">
            <h5 className="mb-3">✅ Thank you for shopping with us!</h5>
            <p className="text-muted">🕐 Processing order...</p>
            <div className="spinner-border text-success mt-3" role="status" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingModal;